import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecuredPagesCanActivateGuard } from '@shared/guards/secured-pages-can-activate.guard';
import { PageNotFoundComponent } from '@views/page-not-found/page-not-found.component';
import { PageNotFoundModule } from '@views/page-not-found/page-not-found.module';
import { KeycloakCanActivateGuard } from '@shared/guards/keycloak-can-activate.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/public/public.module')
      .then(m => m.PublicModule),
  },
  {
    path: '',
    loadChildren: () => import('./views/secured/secured.module')
      .then(m => m.SecuredModule),
    canActivate: [KeycloakCanActivateGuard, SecuredPagesCanActivateGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        useHash: true,
      }
    ),
    PageNotFoundModule,
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
